export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--C.9d276a12.png";